<template>
  <div class="QRWarranty">
    <div :style="{ margin: boxMargin }">
      <div class="flex">
        <div class="flex-fixed qr-area">
          <img class="qr-code" :src="qrImage" />
        </div>
        <div class="flex-fixed detail-area">
          <div class="model-code">{{data.code}}</div>
          <div class="customer-name"><AFitText>{{validCustomerName(data.customer_name)}}</AFitText></div>
          <div class="delivery-date">{{data.contract_date}}</div>
          <div class="size">
            <span class="door-size inline ml-default">{{formatSize(data.sizes.door)}}{{getProductCategory(data)}}</span>
            <span class="rail-size inline">{{formatSize(data.sizes.rail)}}</span>
          </div>
          <div class="specification">{{formatSpecification(data.specification)}}</div>
        </div>
        <div class="flex-auto desc-area">
          <div class="desc">
            {{data.desc}}
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QRCode from 'qrcode'
import AFitText from '@/shared/AFitText';

export default {
  name: "QRWarranty",
  components: {AFitText},
  data() {
    return {
      qrImage: null,
    }
  },
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        }
      }
    },
    data: {
      type: Object,
      require: true
    },
  },
  computed: {
    ...mapGetters(["table_product", "table_product_category"]),
    boxMargin() {
      let margin_top = this.config.margin_top ? this.config.margin_top + "px" : 0;
      let margin_left = this.config.margin_left ? this.config.margin_left + "px" : 0;
      return "" + margin_top + " 0 0 " + margin_left;
    },
  },
  mounted() {
    this.initQRImage();
  },
  methods: {
    initQRImage() {
      let option = {
        errorCorrectionLevel: 'Q',
        type: 'image/jpeg',
        color: {
            light: '#fff',
            dark: '131c2e'
        },
        margin: 2,
        scale: 18,
        rendererOpts: {
            quality: 0.4
        }
      }
      let url = location.origin + '/good/' + this.data.code;
      QRCode.toDataURL(url, option, (err, src) => {
        if (err) { console.error(err) }
        this.qrImage = src;
      });
    },
    formatSize(size) {
      if (!size) { return ''; }
      return Number.parseInt(size);
    },
    formatSpecification(text) {
      if (!text) { return ''; }
      text = text.replace(/:/g,'');
      return text.replace(/EA/g,'');
    },
    validCustomerName(name) {
      return name.substring(0, 20);
    },
    getProductCategory(data) {
      let p = this.table_product.find(p => p.id === data.product_id);
      if (!p || p.categories.length < 1) { return ''; }
      let pc = this.table_product_category.find(pc => pc.id === p.categories[0].product_category_id);
      if (!pc) { return ''; }
      let pc_name = parseInt(pc.name);
      return !isNaN(Number(pc_name)) ? '(' + parseInt(pc.name) + ')' : '(' + pc.name.substring(0,1) + ')';
    },    
  }
}
</script>

<style lang="scss" scoped>
.QRWarranty {
  width: 920px;
  height: 204px;
  padding: 20px 10px 0 10px;
  margin: 0;

  .qr-area {
    width: 135px;
    margin-top: 48px;
    margin-left: 3px;
  }
  .qr-code {
    width: 140px;
  }
  .detail-area {    
    margin-top: 35px;
    margin-left: 60px;
    font-size: 20px;
    width: 200px;
    > div {
      &:not(:last-child) {
        height: 30px;
      }
    }
  }
  .desc-area {
    .desc {
      width: 400px;
      margin-top: 160px;
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .model-code,
  .customer-name,
  .delivery-date,
  .door-size,
  .rail-size {
    text-align: center;    
    height: 32px;
    line-height: 32px;
  }
  .model-code {
    font-size: 16px;
  }
  .specification {
    word-break: break-all;
    font-size: 12px;
    padding: 5px 5px 0 10px;
  }
  .door-size,
  .rail-size {
    font-size: 16px;
    width: 70px;
  }
  .rail-size { 
    margin-left: 50px;
  }
}
</style>
<style type="text/css" media="print"> 
.QRWarranty  {
  size: 150mm 40mm;
  color: #000 !important;
  font-family: "돋움";
  page-break-after: always;
} 
</style>